import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { MasonryAd } from "@/ads/components/MasonryAd";
import { useI18n } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { ExpandIcon } from "@gemini/icons";
import { Button } from "@gemini/ui";
import { useGalleryContext } from "../../contexts";
import { MasonryPicture } from "./MasonryPicture";
import { MasonryContainer, MasonryWrapper } from "./ui";
export const Masonry = ({ testId, openOnSlideIndex }) => {
    const { masonryItems, galleryCount } = useGalleryContext();
    const { t } = useI18n();
    return (_jsxs(MasonryWrapper, { testId: testId, imagesCount: galleryCount, children: [masonryItems.map((itemDatas, index) => {
                const { type, item } = itemDatas;
                const key = `imageContainer-${type}-${index}`;
                return (_jsx(MasonryContainer, { children: type === "full" ? (_jsx(MasonryPicture, { testId: testId, index: index, openOnSlideIndex: openOnSlideIndex, 
                        // @ts-ignore
                        image: item[0], type: type })) : (_jsx(_Fragment, { children: item.map((image, index) => {
                            return (_jsx(MasonryPicture, { testId: testId, index: index, openOnSlideIndex: openOnSlideIndex, image: image, type: type }, image.key));
                        }) })) }, key));
            }), _jsx(MasonryAd, {}), _jsx(Box, { position: "fixed", top: "76px", left: "50%", transform: "translateX(-50%)", display: "flex", gap: "spacing.12", children: _jsx(Button, { onPress: () => openOnSlideIndex(0), variant: "secondary-floating", icon: ExpandIcon, size: "40", testId: `${testId}-fullscreen-cta`, children: t("gallery.masonry.fullscreen.cta") }) })] }));
};
